module.exports = __webpack_public_path__ + "img/headhunting.7ee6ca12.svg";